export const apiCreate = (): string => '/users/ipAllowed/create'
export const apiList = (id?: string): string =>
  !id ? '/users/ipAllowed/' : `/users/ipAllowed/view/${id}`
export const apiUpdate = (id: string): string => `/users/ipAllowed/update/${id}`
export const apiDelete = (id: string): string => `/users/ipAllowed/delete/${id}`
